import { Injectable } from '@angular/core';
import { Observable as __Observable, Observable, combineLatest } from 'rxjs';
import { AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { OrderLocation } from '../models/order_location'

@Injectable({
  providedIn: 'root'
})
export class OrderLocationService {

  private collectionName = 'order_location';
  constructor(private firestore: AngularFirestore) { }

  orderById(id: string): __Observable<OrderLocation> {
    return this.firestore.collection<OrderLocation>(this.collectionName).doc(id)
      .valueChanges();
  }
}
